/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type LanguageFilterConfigColumn = (typeof LanguageFilterConfigColumn)[keyof typeof LanguageFilterConfigColumn];

export const LanguageFilterConfigColumn = {
  language: 'language',
} as const;
